import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../components/utils/Model';
import Button from '../../../components/utils/Button';
import portinActivationAction from '../../../redux/portinActivation/actions';
import Alert from '../../../components/utils/Alert';

const { cancelkPortActivation, resetMessage, resetSucessMessage } = portinActivationAction;

const CancelPortinActivation = ({ modal, row, close, search }) => {
    const dispatch = useDispatch();
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const { cancelPortActivationLoading, cancelPortActivationMessage, cancelPortActivationError } = useSelector((state) => state.portinActivation);
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            remark: ''
        }
    });

    useEffect(() => {
        if (cancelPortActivationMessage) {
            close();
        }
        if (cancelPortActivationError !== null && cancelPortActivationError !== undefined) {
            displayAlert(cancelPortActivationError, 'alert-danger');
        }

    }, [cancelPortActivationMessage, cancelPortActivationError]);

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
        dispatch(resetSucessMessage());
    }

    const onSubmit = (data) => {
        dispatch(cancelkPortActivation({
            activationId: row.ID,
            bulktransactionid: row.BulkTransactionID,
            remark: data.remark,
            search
        }));
    }

    return (
        <Modal
            showModal={modal}
            title={'CANCEL PORTIN REQUEST: '}
            subTitle={<span style={{ color: '#990404' }}>{row.TransactionID}</span>}
            onHide={close}
            width={500}
            showFooter={false}
        >
            {showAlert && <div className='mt-4'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-row">
                    <div className="col-md-12 mb-3">
                        <label>Remark</label>
                        <textarea className="form-control" placeholder="Enter Remark" id="remark" name="remark" rows="4" cols="30" {...register("remark", {
                            required: "Remark is required"
                        })}>
                        </textarea>
                        {errors.remark && (<div className="invalid-feedback">{errors.remark.message}</div>)}
                    </div>
                </div>
                <hr />
                <div className='text-right row'>
                    <div className="col-md-12">
                        <button type="button" className="btn btn-secondary mr-2" onClick={close}>Close</button>
                        <Button title="Submit" style="minWidth:80px" loading={cancelPortActivationLoading} buttonClass="btn btn-primary" buttonType='submit' />
                    </div>
                </div>
            </form>
        </Modal>
    )
}

export default CancelPortinActivation;